import React from 'react'
import { useSelector } from 'react-redux';
import { NoMatchFound } from '../../Component/NoMatchFound/NoMatchFound';

export default function GenAIContent() {
  const searchState = useSelector(state=>state.search);
    const conatinerStyles={
        padding:'20px'
    }
    const textStyle={
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: '300',
        lineHeight: '24px',
        textAlign: 'left',
        color: '#5C667B'
    }
    const replaceHere=(str)=>{
      let newstr = str.replaceAll('\n','<br/>');
      return newstr;
    }
  return (
    <div style={conatinerStyles}>
        {!searchState.isExternal && searchState.isLoading && <p style={textStyle}>Generating...</p>}
        {searchState.isExternal && searchState.isLoading && <p style={textStyle}>Researching...This may take few minutes</p>}
        {searchState.isRegenerating && <p style={textStyle}>Regenerating...</p>}
        {!searchState.isRegenerating && !searchState.isLoading && searchState.origSearchData.length === 0 && searchState.generativeText==='' && <div style={{height:'280px', display:'flex',justifyContent:'center',alignItems:'center'}}><NoMatchFound/></div>}
        {!searchState.isRegenerating && !searchState.isLoading && searchState.generativeText !== "" && <div id="genaisummary" style={textStyle} dangerouslySetInnerHTML={{
                  __html: replaceHere(searchState.generativeText),
                }}></div>} 
    </div>
  )
}
